import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import {
  DialogContentBase,
  DialogRef,
  DialogService,
} from "@progress/kendo-angular-dialog";
import { NotificationService } from "@progress/kendo-angular-notification";
import { AgendaTypeService } from "app/intake/note/agenda-type.service";
import { NoteTypeService } from "app/intake/note/note-type.service";
import { UserProfile } from "app/_models";
import { CedConfirmDialogService, CedNotificationService } from "ced-ng-library";
import { combineLatest, forkJoin, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GroupRolesService } from "../group-roles-note-type.service";
import { AuthorizationRoleInheritanceModel } from "../models/AuthorizationRoleInheritanceModel";
import { RoleGroupModel } from "../models/RoleGroupModel";
import { RoleService } from "../role.service";

@Component({
  selector: "app-role-details",
  templateUrl: "./role-details.component.html",
})
export class RoleDetailsComponent
  extends DialogContentBase
  implements OnInit, OnDestroy
{
  private selectedItem: RoleGroupModel = null;
  public roleGroupForm = new FormGroup({});
  private _subject$: Subject<boolean> = new Subject();
  public profile: UserProfile = new UserProfile();
  errorPopup: any = null;
  private authorizationRoleInheritances: AuthorizationRoleInheritanceModel[] =
    [];
  selectedFonctionnality: RoleGroupModel;
  public noteTypeList = [];
  public selectedRoleGroupNoteType = [];
  public selectedRoleGroupAgendaType = [];
  roles: any[]=[];
  public agendaList: any[]=[];

  constructor(
    dialog: DialogRef,
    private noteTypeService: NoteTypeService,
    private groupRolesService: GroupRolesService,
    private roleService: RoleService,
    private agendaTypeService:AgendaTypeService,
    private translateService: TranslateService,
    private cedNotificationService: CedNotificationService
  ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.initForm();
    this.getselectedRoleGroupTypes();
    this.getFonctionnalities();
  }

  initForm(){
    this.roleGroupForm = new FormGroup({
      name: new FormControl(this.selectedItem ? this.selectedItem.id : null),
    });
    if(this.selectedItem != null){
      this.roleGroupForm.controls["name"].clearValidators();
      this.roleGroupForm.controls["name"].updateValueAndValidity();
    }
    else{
      this.roleGroupForm.controls["name"].setValidators(
        Validators.required
      );
      this.roleGroupForm.controls["name"].updateValueAndValidity();
    }
  }

  getFonctionnalities(){
    let getAuthorizationRoles = this.roleService.getAuthorizationRoles();
    let getAuthorizationRolesInheritance = this.roleService.getAuthorizationRolesInheritance();
    combineLatest(getAuthorizationRoles, getAuthorizationRolesInheritance).pipe(takeUntil(this._subject$))
    .subscribe(([authorizationRoles, authorizationRolesInheritance]) => {
      let roles = authorizationRoles as any[];
      this.authorizationRoleInheritances = [];
      if(this.selectedItem != null)
        this.authorizationRoleInheritances = (authorizationRolesInheritance as AuthorizationRoleInheritanceModel[]).filter(i=>i.authorizationGroupRoleId == this.selectedItem.id );

      roles.forEach(r=>{
        let item = new AuthorizationRoleInheritanceModel();
        item.authorizationRoleId = r.id;
        let roleInheritance = this.authorizationRoleInheritances.find(i=>i.authorizationRoleId == r.id);
        item.id = roleInheritance ? roleInheritance.id : null;
        item.operationCreate = roleInheritance ? roleInheritance.operationCreate : false;
        item.operationRead = roleInheritance ? roleInheritance.operationRead :
                            (this.selectedItem &&  this.selectedItem.id) ? false: true;
        item.operationUpdate = roleInheritance ? roleInheritance.operationUpdate : false;
        item.operationDelete = roleInheritance ? roleInheritance.operationDelete : false;
        item.operationExecute = roleInheritance ? roleInheritance.operationExecute : false;
        this.roles = [...this.roles, item];
      })
    });
  }

  getselectedRoleGroupTypes() {
    forkJoin([
      this.groupRolesService.GetByGroupRoleId(this.roleGroupForm.controls.name.value),
      this.noteTypeService.getAll(true),
      this.agendaTypeService.getAgendaTypeByCulture(this.translateService.currentLang,true)
    ]).subscribe((results: any[]) => {
        this.selectedRoleGroupNoteType = results[0].groupRolesNoteTypes;
        this.selectedRoleGroupAgendaType = results[0].groupRolesAgendaTypes;
        results[1].forEach((element) => {
          element.selected = false;
          if (
            this.selectedRoleGroupNoteType.find(
              (e) => e.groNoteTypeId == element.notId
            ) != null
          ) {
            element.selected = true;
          }
          this.roleGroupForm.controls[element.notCode] = new FormControl();
          this.noteTypeList = [...this.noteTypeList, element];
        });
        results[2].forEach((element) => {
          element.selected = false;
          if (
            this.selectedRoleGroupAgendaType.find(
              (e) => e.groAgendaTypeId == element.ageId
            ) != null
          ) {
            element.selected = true;
          }
          this.agendaList =  [...this.agendaList, element];
        });
        this.agendaList = this.agendaList.sort((a, b) => a.ageShortName.toLowerCase() > b.ageShortName.toLowerCase() ? 1 : -1);
      });
  }

  public onSaveAction() {
    this.roles.forEach(r=>{
      r.authorizationGroupRoleId = this.roleGroupForm.controls.name.value;
    })
    let roleGroup = new RoleGroupModel();
    roleGroup.id = this.roleGroupForm.controls.name.value;
    roleGroup.authorizationRoleInheritances =
      this.roles;
    if (this.roleGroupForm.valid) {
      if(this.selectedItem != null){
        this.updateRoleGroup(roleGroup);
      }
      else{
        this.addRoleGroup(roleGroup);
      }
    }
    else{
      this.cedNotificationService.error("NOTIFICATIONS.ROLE_NAME_REQUIRED");
    }
  }

  updateRoleGroup(roleGroup) {
    this.roleService
    .updateRoleGroup(roleGroup)
    .pipe(takeUntil(this._subject$))
    .subscribe(
      () => {
        this.setRoleGroupTypes();
      },
      (err) => {
        this.cedNotificationService.error(err);
      }
    );
}

  addRoleGroup(roleGroup) {

    this.roleService
      .addRoleGroup(roleGroup)
      .pipe(takeUntil(this._subject$))
      .subscribe(
        () => {
          this.setRoleGroupTypes();
        },
        (err) => {
          this.cedNotificationService.error(err);
        }
      );
  }


  setRoleGroupTypes() {
    let noteTypeRoleGroupListToSet = [];
    this.noteTypeList.forEach((noteType) => {
      if (noteType.selected) {
        let elementToset = {
          groAuthorizationGroupRoleId: this.roleGroupForm.controls.name.value,
          groCreatedBy: this.profile.fullName,
          groNoteTypeId: noteType.notId,
          groLastModifiedBy: this.profile.fullName,
        };
        noteTypeRoleGroupListToSet.push(elementToset);
      }
    });
    let agendaTypeRoleGroupListToSet = [];
    this.agendaList.forEach((agendaType) => {
      if (agendaType.selected) {
        let elementToset = {
          groAuthorizationGroupRoleId: this.roleGroupForm.controls.name.value,
          groCreatedBy: this.profile.fullName,
          groAgendaTypeId: agendaType.ageId,
          groLastModifiedBy: this.profile.fullName,
        };
        agendaTypeRoleGroupListToSet.push(elementToset);
      }
    });
  let RoleGroupListToSet = {groupRolesNoteTypes:noteTypeRoleGroupListToSet,groupRolesAgendaTypes:agendaTypeRoleGroupListToSet,groupRoleId:this.roleGroupForm.controls.name.value}
      this.groupRolesService
        .save(RoleGroupListToSet)
        .pipe(takeUntil(this._subject$))
        .subscribe(
          () => {
            this.cedNotificationService.success("NOTIFICATIONS.ROLES_UPDATE_SUCCESS");
            this.dialog.close(null);
          },
          (err) => {
            this.cedNotificationService.error(err);
          }
        );
}

public onCancelAction() {
    this.dialog.close(true);
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}
